import apiWorker from '../apiWorker'

const microsoft = {
    merge              : ()      => apiWorker('post',  `/api/merge_final`),
    merge2              : (d)      => apiWorker('post',  `/api/merge_final2`, d),
}

export default microsoft;